var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"py-4 px-2 toolbar-content-padding-y-none",attrs:{"absolute":"","color":_vm.background,"height":"auto","flat":""}},[_c('v-container',[_c('v-row')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }